export default __webpack_public_path__ + "static/media/Snack_popup_content1.e4e0e083.jpg";